import { HttpInterceptorFn } from '@angular/common/http';

import { XSRF_HEADER_NAME } from 'app/constants';
import { environment } from 'environments/environment';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function getCookie(name: string): string | null {
    const match = document.cookie.split('; ').find((row) => row.startsWith(name + '='));
    return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
}

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
    if (!MUTATING_METHODS.has(req.method)) {
        return next(req);
    }

    const token = getCookie(environment.xsrfCookieName);

    if (!token) {
        return next(req);
    }

    return next(req.clone({ setHeaders: { [XSRF_HEADER_NAME]: token } }));
};
